<template>
  <div class="app-function-switch-container animated fadeInRight">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('appFunctionSwitch.title') }}</span>
        <el-button type="text" icon="el-icon-refresh" @click="refresh()" />
      </div>

      <!-- 说明 -->
      <el-alert :title="$t('appFunctionSwitch.desc')" type="info" :closable="false" show-icon class="tip-alert" />

      <!-- 开关列表 -->
      <el-table :data="switches" border style="width:100%" v-loading="loading">
        <el-table-column prop="groupName" :label="$t('appFunctionSwitch.table.groupName')" min-width="200" />
        <el-table-column prop="groupCode" :label="$t('appFunctionSwitch.table.groupCode')" width="220" align="center" />
        <el-table-column :label="$t('appFunctionSwitch.table.openFlag')" width="180" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.openFlag === '1'"
              :active-text="$t('appFunctionSwitch.open')"
              :inactive-text="$t('appFunctionSwitch.closed')"
              @change="val => handleSwitchChange(scope.row, val)" />
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('appFunctionSwitch.table.remark')" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" :label="$t('appFunctionSwitch.table.updateTime')" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-empty v-if="!loading && switches.length === 0" :description="$t('appFunctionSwitch.empty')" />
    </el-card>
  </div>
</template>

<script>
import { listAppFunctionSwitches, updateAppFunctionSwitch } from '@/api/property/appFunctionSwitchApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'AppFunctionSwitchManageList',
  data() {
    return {
      loading: false,
      communityId: '',
      switches: []
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.refresh()
  },
  methods: {
    refresh() {
      this._listSwitches()
    },
    /**
     * 查询当前小区的功能开关
     */
    async _listSwitches() {
      try {
        this.loading = true
        const { data } = await listAppFunctionSwitches({
          page: 1,
          row: 100,
          communityId: this.communityId
        })
        this.switches = data || []
      } catch (e) {
        this.switches = []
      } finally {
        this.loading = false
      }
    },
    /**
     * 切换开关：先二次确认，确认后调接口，失败则回滚
     *
     * @param row 当前行
     * @param val true 开放 / false 关闭
     */
    async handleSwitchChange(row, val) {
      const openFlag = val ? '1' : '0'
      const confirmText = val
        ? this.$t('appFunctionSwitch.enableConfirm')
        : this.$t('appFunctionSwitch.disableConfirm')

      try {
        await this.$confirm(confirmText, this.$t('appFunctionSwitch.confirmTitle'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        })
      } catch (e) {
        // 用户取消：不修改，el-switch 绑的是 :value 非 v-model，无需手动回滚
        return
      }

      try {
        await updateAppFunctionSwitch({
          switchId: row.switchId,
          openFlag: openFlag
        })
        // 本地同步，避免整页重新请求造成闪烁
        row.openFlag = openFlag
        this.$message.success(this.$t('appFunctionSwitch.updateSuccess'))
      } catch (e) {
        this.$message.error(this.$t('appFunctionSwitch.updateFailed'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-function-switch-container {
  padding: 0;
}

.tip-alert {
  margin-bottom: 16px;
}

.box-card {
  margin-bottom: 20px;
}
</style>
